import { render, staticRenderFns } from "./AModal-reporteFeria2.vue?vue&type=template&id=6085e3e3"
import script from "./AModal-reporteFeria2.vue?vue&type=script&lang=js"
export * from "./AModal-reporteFeria2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports